module.exports = __webpack_public_path__ + "img/github.e87fc908.png";